module.exports = __webpack_public_path__ + "app/assets/fonts/glyphicons-halflings-regular.eot?f4769f9bdb7466be65088239c12046d1";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/glyphicons-halflings-regular.eot
// module id = 175
// module chunks = 1